import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Auth } from '../auth';
import { TranslationManager } from 'src/common/translation';

@Injectable()
export class AuthenticationGuard implements CanActivate {

    constructor(private router: Router) { }
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
      return new Promise<boolean>((resolve) => {
          TranslationManager.init().then(() => {
              Auth.init().then(() => {
                  resolve(true);
              }).catch(() => {
                  resolve(false);
              })
          }).catch(() => {
              resolve(false);
          })
      })
  }
}
